import React, { useEffect, useState } from "react";
import { navigate } from "gatsby";
import { buildCategoryPath } from "../../utils/path-utils";

interface Category {
  id: string;
  name: string;
  slug: string;
  parentDatabaseId?: number;
  databaseId: number;
}

interface Tag {
  id: string;
  name: string;
  slug: string;
}

interface PostFilterProps {
  allCategories: Category[];
  allTags: Tag[];
  currentCategoryPath: string;
  currentTagSlug: string | null;
  currentMainCategoryId: string | null;
  currentSubcategoryId: string | null;
  className?: string;
}

const PostFilter: React.FC<PostFilterProps> = ({
  allCategories = [],
  allTags,
  currentCategoryPath,
  currentTagSlug,
  currentMainCategoryId,
  currentSubcategoryId,
  className,
}) => {
  console.log("PostFilter props:", {
    currentMainCategoryId,
    currentSubcategoryId,
    currentTagSlug,
  });

  const [scrolled, setScrolled] = useState(false);

  // Detect scroll inside `.contentWrapper`
  useEffect(() => {
    const contentWrapper = document.querySelector(".contentWrapper");

    if (!contentWrapper) return;

    const handleScroll = () => {
      setScrolled(contentWrapper.scrollTop > 450);
    };

    contentWrapper.addEventListener("scroll", handleScroll);
    return () => contentWrapper.removeEventListener("scroll", handleScroll);
  }, []);

  const topLevelCategories = allCategories.filter(cat => !cat.parentDatabaseId);
  const subcategoriesOfSelectedMain = currentMainCategoryId
    ? allCategories.filter(
        cat =>
          cat.parentDatabaseId ===
          allCategories.find(mainCat => mainCat.id === currentMainCategoryId)
            ?.databaseId
      )
    : [];

  const buildPath = (
    mainCatId: string | null,
    subCatId: string | null,
    tagSlug: string | null
  ) => {
    let category;
    if (subCatId) {
      category = allCategories.find(cat => cat.id === subCatId);
    } else if (mainCatId) {
      category = allCategories.find(cat => cat.id === mainCatId);
    }

    let path = "/";
    if (category) {
      path = `/${buildCategoryPath(category, allCategories)}/`;
    }

    if (tagSlug) {
      path += `tag/${tagSlug}/`;
    }

    return path;
  };

  const handleMainCategoryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newMainCatId = event.target.value || null;
    navigate(buildPath(newMainCatId, null, null));
  };

  const handleSubcategoryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newSubCatId = event.target.value || null;
    navigate(buildPath(currentMainCategoryId, newSubCatId, null));
  };

  const handleTagChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newTagSlug = event.target.value || null;
    navigate(buildPath(currentMainCategoryId, currentSubcategoryId, newTagSlug));
  };

  return (
    <div
      className={className}
      style={{
        background: scrolled
          ? "var(--color-white)" // solid when scrolling
          : "linear-gradient(to bottom, var(--color-white) 0%, rgba(255, 255, 255, 0%) 100%)", // gradient at top
        display: "flex",
        justifyContent: "space-between",
        margin: "0 -2vw",
        padding: "0.6vw 2vw .1vw 2vw",
        position: "sticky",
        top: "0",
        zIndex: 1,
        transition: "background 0.3s ease",
      }}
    >
      {/* Main Category Dropdown */}
      <div>
        <select
          id="main-category-select"
          className="badge"
          onChange={handleMainCategoryChange}
          value={currentMainCategoryId || ""}

        >
          <option key="all-countries" value="">
            Select country
          </option>
          {topLevelCategories.map(category => (
            <option key={`category-${category.id}-${category.slug}`} value={category.id}>
              {category.name}
            </option>
          ))}
        </select>
      </div>

      {/* Subcategory Selector */}
      {currentMainCategoryId && subcategoriesOfSelectedMain.length > 0 && (
        <div>
          <select
            id="subcategory-select"
            className="badge"
            onChange={handleSubcategoryChange}
            value={currentSubcategoryId || ""}
          >
            <option key="all-areas" value="">
              All areas
            </option>
            {subcategoriesOfSelectedMain.map(subcategory => (
              <option
                key={`subcategory-${subcategory.id}-${subcategory.slug}`}
                value={subcategory.id}
              >
                {subcategory.name}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* Tags Selector */}
      <div>
        <select
          id="tag-select"
          className="badge"
          onChange={handleTagChange}
          value={currentTagSlug || ""}
          
        >
          <option key="all-tags" value="">
            Select activity
          </option>
          {allTags.map(tag => (
            <option key={`tag-${tag.id || tag.slug}`} value={tag.slug}>
              {tag.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default PostFilter;
